import { useLocation } from "react-router-dom";

import { ROUTES, ROUTE_LIST } from "routers/shared/util/consts";
import isRouteMatch from "shared/util/isRouteMatch";

const BLACKLISTED_ROUTES = [
	...ROUTES.Offboarding,
	...ROUTES.Onboarding,
	...ROUTES.PasswordReboarding,
	...ROUTES.PhoneWall,
	...ROUTES.RealName,
	...ROUTES.StandaloneConversation,
];

export default function useIsWhitelistedNotificationRoute(blacklistedRoutes = []) {
	const location = useLocation();
	const is404 = !isRouteMatch(location, ROUTE_LIST);
	const mergedBlacklistedRoutes = [...BLACKLISTED_ROUTES, ...blacklistedRoutes];
	return !is404 && !isRouteMatch(location, mergedBlacklistedRoutes);
}



// WEBPACK FOOTER //
// ./src/apps/notifications_footer/util/useIsWhitelistedNotificationRoute.js